import UAParser from 'ua-parser-js';

export const userOperatingSystemIs = (os: string) => {
    const parser = new UAParser();

    return parser.getOS().name === os;
};
